import { ReactNode } from "react";
import LeftArrowIcon from "../../../../../../../../../../../assets/svg/left-arrow-icon";
import { CommentAuthor } from "./CommentAuthor";
import { TicketCommentInput } from "./TicketCommentInput";
import { PermissionDisabledWrapper } from "../../../../../../PermissionDisabledWrapper";

interface ActivityThreadViewProps {
  threadAuthorName?: string;
  threadSubject?: string;
  threadEmailCount?: number;
  ticketId?: string;
  parentCommentId?: string;
  showCommentInput?: boolean;
  canUpdate?: boolean;
  onBack: () => void;
  children: ReactNode;
}

const ActivityThreadView = ({
  threadAuthorName,
  threadSubject,
  threadEmailCount,
  ticketId,
  parentCommentId,
  showCommentInput = true,
  canUpdate = true,
  onBack,
  children,
}: ActivityThreadViewProps) => (
  <>
    <div className="flex items-center justify-between h-[50px] px-3 border-b border-border-gray dark:border-border-gray-dk shrink-0">
      <div className="flex items-center gap-1">
        <h3 className="text-base font-semibold text-verba-indigo dark:text-verba-indigo-dk">
          Activity
        </h3>
      </div>
    </div>

    <div className="flex items-center justify-between h-[50px] px-3 border-b border-border-gray dark:border-border-gray-dk shrink-0">
      <button
        className="flex items-center gap-1 cursor-pointer hover:opacity-80 shrink-0"
        onClick={onBack}
      >
        <LeftArrowIcon className="w-4 h-4 text-heading-text dark:text-heading-text-dk" />
        <span className="text-md font-semibold text-heading-text dark:text-heading-text-dk">
          {threadSubject ? "Thread" : "Back"}
        </span>
      </button>
      {threadSubject ? (
        <div className="flex items-center gap-[6px] min-w-0 overflow-hidden">
          <span className="text-md font-medium text-heading-text dark:text-heading-text-dk truncate">
            {threadSubject}
          </span>
          {threadEmailCount != null && threadEmailCount > 0 && (
            <>
              <span className="text-gray-placeholder dark:text-gray-placeholder-dk shrink-0">
                &middot;
              </span>
              <span className="text-xs font-medium text-analytics-gray dark:text-analytics-gray-dk whitespace-nowrap shrink-0">
                {threadEmailCount} {threadEmailCount === 1 ? "Email" : "Emails"}
              </span>
            </>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-[6px] min-w-0 overflow-hidden">
          <span className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk shrink-0">
            Thread by
          </span>
          <div className="flex items-center gap-[5px] min-w-0 overflow-hidden">
            <CommentAuthor
              userName={threadAuthorName}
              avatarSize={20}
              nameClassName="text-md font-medium text-heading-text dark:text-heading-text-dk truncate"
            />
          </div>
        </div>
      )}
    </div>

    <div className="flex-1 overflow-y-auto" data-activity-scroll>
      {children}
    </div>

    {showCommentInput && (
      <PermissionDisabledWrapper disabled={!canUpdate}>
        <TicketCommentInput
          ticketId={ticketId}
          parentCommentId={parentCommentId}
        />
      </PermissionDisabledWrapper>
    )}
  </>
);

export default ActivityThreadView;
